    export function hasAccess(path) {
        const permissions = JSON.parse(localStorage.getItem('userPermissions'))
        if (!permissions) {
          return false
        }
        return permissions.some(permission => {
          if (permission.componentName !== null) {
            return permission.componentName === path && permission.access
          } else {
            return permission.subMenu.some(subMenu => {
              if (subMenu.componentName !== null) {
                return subMenu.componentName === path && subMenu.access
              } else {
                return subMenu.subMenu.some(subSubMenu => {
                  return subSubMenu.componentName === path && subSubMenu.access
                })
              }
             
            })
          }
        } 
      )
      }
